import strapiAxios from './strapiAxiosClient'

export const getCategories = async (): Promise<any> => {
    return new Promise((resolve, reject) => {
        const url = `/help/categories`
        strapiAxios.get(url).then(async (response) => {
            resolve(response.data.data)
        }).catch((error) => {
            console.error('Error fetching categories:', error)
            reject(error)
        })
    })
}

export const getContent = async (args: { id: string }): Promise<any> => {
    return new Promise((resolve, reject) => {
        const url = `/help/article/${args.id}`
        strapiAxios.get(url).then(async (response) => {
            resolve(response.data.data)
        }).catch((error) => {
            console.error('Error fetching article content:', error)
            reject(error)
        })
    })
}

export const searchArticles = async (args: { searchText: string, pageNo: number, pageSize: number }): Promise<any> => {
    return new Promise((resolve, reject) => {
        const url = `/help/search?q=${args.searchText}&page=${args.pageNo}&pageSize=${args.pageSize}`
        strapiAxios.get(url).then(async (response) => {
            resolve(response.data)
        }).catch((error) => {
            console.error('Error occurred while searching content:', error)
            reject(error)
        })
    })
}

export const searchAllArticles = async (args: { searchText: string, page: number, pageSize: number }): Promise<any> => {
    return new Promise((resolve, reject) => {
        const url = `/help/search?q=${args.searchText}&page=${args.page}&pageSize=${args.pageSize}`
        strapiAxios.get(url).then(async (response) => {
            resolve(response.data)
        }).catch((error) => {
            console.error('Error occurred while searching content:', error)
            reject(error)
        })
    })
}

export const getOnBoardingCards = async (): Promise<any> => {
    return new Promise((resolve, reject) => {
        const url = `/on-boarding-cards?populate=*&filters[device][$eq]=web&sort[0]=order:asc`
        strapiAxios.get(url).then(async (response) => {
            resolve(response.data)
        }).catch((error) => {
            console.error('Error occurred while searching content:', error)
            reject(error)
        })
    })
}